import { adminApi } from './admin-api';
import type { AdminFilters, AdminDomain, AdminDomainDetail, ApiResponse, PaginatedResponse } from '@/types/admin.types';

export const adminDomainsService = {
  getAll: async (filters: AdminFilters = {}): Promise<PaginatedResponse<AdminDomain>> => {
    const params = new URLSearchParams();
    if (filters.page) params.set('page', String(filters.page));
    if (filters.limit) params.set('limit', String(filters.limit));
    if (filters.search) params.set('search', filters.search);
    if (filters.sortBy) params.set('sortBy', filters.sortBy);
    if (filters.sortOrder) params.set('sortOrder', filters.sortOrder);
    const response = await adminApi.get(`/admin/domains?${params.toString()}`);
    return response.data;
  },

  getById: async (uuid: string): Promise<ApiResponse<AdminDomainDetail>> => {
    const response = await adminApi.get(`/admin/domains/${uuid}`);
    return response.data;
  },

  forceSync: async (uuid: string): Promise<{ message: string }> => {
    const response = await adminApi.post(`/admin/domains/${uuid}/force-sync`);
    return response.data;
  },

  toggleArchive: async (uuid: string): Promise<{ message: string }> => {
    const response = await adminApi.post(`/admin/domains/${uuid}/toggle-archive`);
    return response.data;
  },
};
